import ContentShell from './ContentShell'
import BlogSeo from './BlogSeo'
import Breadcrumbs from './Breadcrumbs'
import TableOfContents from './TableOfContents'
import RelatedPosts from './RelatedPosts'
import CtaBlock from './CtaBlock'
import { getRelatedPosts } from '../../lib/blog/posts'
import type { BlogPost } from '../../lib/blog/types'

const fmtDate = (iso: string) =>
  new Date(`${iso}T00:00:00Z`).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })

/** Full article page: SEO head + breadcrumb + TOC + body + related + CTA. */
export default function PostLayout({ post }: { post: BlogPost }) {
  const related = getRelatedPosts(post)
  return (
    <ContentShell>
      <BlogSeo post={post} />
      <article className="mx-auto max-w-3xl pt-6">
        <Breadcrumbs
          crumbs={[
            { name: 'Home', path: '/' },
            { name: 'Blog', path: '/blog' },
            { name: post.categoryLabel, path: `/blog/category/${post.category}` },
            { name: post.title, path: `/blog/${post.slug}` },
          ]}
        />

        <header className="mb-8">
          <h1 className="text-[clamp(2rem,3vw+1rem,2.8rem)] font-bold tracking-tight text-ink leading-tight m-0">
            {post.title}
          </h1>
          <p className="text-ink-soft mt-4 text-[0.9rem]">
            By {post.author} · <time dateTime={post.date}>{fmtDate(post.date)}</time>
          </p>
        </header>

        {post.toc.length > 1 && (
          <div className="mb-8">
            <TableOfContents items={post.toc} />
          </div>
        )}

        <div className="prose-content" dangerouslySetInnerHTML={{ __html: post.html }} />

        <CtaBlock funnelStage={post.funnel_stage} />
        <RelatedPosts posts={related} />
      </article>
    </ContentShell>
  )
}
